import { put, call, takeLatest, debounce } from "redux-saga/effects";
import { showErrorToast } from "util/toastUtils";
import { decryptJson } from "util/react-ec-utils";
import { getEmployeeDetails } from "redux/employee/employeeAPI";
import { 
    employeeReportDetailedTableFailure,
    employeeReportDetailedTableSuccess,
    employeeReportDropDownFilterFailure, 
    employeeReportDropDownFilterSuccess 
} from "./salesEmployeeTabSliceActions";
import { 
    GET_EMPLOYEE_REPORT_DETAILED_TABLE_REQUEST, 
    GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_REQUEST 
} from "./salesEmployeeTabSliceConstants";
import { getEmployeeSummaryDetailedTable } from "./salesEmployeeTabSliceApi";


// getEmployeeDropDownFilter
function* getEmployeeDropDownFilter(action) {
    try {
        const response = yield call(getEmployeeDetails, action.payload);
        if (response.status === 200) {
            const employeeListData = decryptJson(response?.data?.data)
            yield put(employeeReportDropDownFilterSuccess(employeeListData));
        } else {
            const errorMessage = response?.data?.message != "" ? response?.data?.message : 'Please Try Again Later';
            response?.status !== 403 && showErrorToast(errorMessage);
            yield put(employeeReportDropDownFilterFailure({ message: errorMessage }));
        }
    } catch (err) {
        yield put(employeeReportDropDownFilterFailure({ message: "please Try Again" }));
    }
}

// getEmployeeSummaryDetailedTableSaga
function* getEmployeeSummaryDetailedTableSaga(action) {
    try {
        const response = yield call(getEmployeeSummaryDetailedTable, action.payload);
        if (response.status === 200) {
            const employeeListData = decryptJson(response?.data?.encryptedText)
            yield put(employeeReportDetailedTableSuccess(employeeListData));
        } else {
            const errorMessage = response?.data?.message != "" ? response?.data?.message : 'Please Try Again Later';
            response?.status !== 403 && showErrorToast(errorMessage);
            yield put(employeeReportDetailedTableFailure({ message: errorMessage }));
        }
    } catch (err) {
        yield put(employeeReportDetailedTableFailure({ message: "please Try Again" }));
    }
}

export default function* watchSalesEmployeeTabSliceRequest() {
    yield takeLatest(GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_REQUEST, getEmployeeDropDownFilter);
    yield takeLatest(GET_EMPLOYEE_REPORT_DETAILED_TABLE_REQUEST, getEmployeeSummaryDetailedTableSaga);
}